













































































import VueOptions from '@utils/VueOptions'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'
import AudienceCreativeFilter from '@ui/AudienceCreative/AudienceCreativeFilter'

settings =
  name: 'SpaceResourceList'

  vue:
    props: ['spaces', 'options', 'actions', 'infiniteWrapper']
    components: {
      ResourceList,
      LoadingIndicator,
      AudienceCreativeFilter,
    }

    data: ->
      isAllSelected: false
      selectedSpaces: []
      nextPage: 1
      target:
        q: ''

    computed:
      components: ->
        'space-card': () => import('@ui/cards/SpaceCard')

      resourceKey: -> @options?.resourceKey || 'spaces'

      listItemActions: -> {}

    methods:
      hiApplyFilters: ->
        @$refs.infiniteLoading.stateChanger.reset()
        @nextPage = 1
        @actions.fetchResource null, @resourceKey, @target, { page: @nextPage }
        @nextPage += 1

      hiSearchChange: ->

      hiAddInventory: ->
        query = { supplierId: @options?.supplierId }
        @$router.push { name: 'SpaceCreatePage', query }

      hiSelectAll: (checked) ->
        @selectedSpaces = []
        @selectedSpaces.push(...@spaces) if checked

      hiDeselectAll: ->
        @isAllSelected = false
        @selectedSpaces = []

      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @targetPayload(), { page: @nextPage })
        @nextPage += 1

      hiNavToSpaceEditor: ->
        spaces = 'all' if @isAllSelected
        spaces ||= @selectedSpaces.map((item) -> item.id)
        @actions?.bulkEdit spaces

      targetPayload: -> {}

    watch:
      spaces: (value) ->
        @selectedSpaces.push(...@spaces) if @isAllSelected

export default VueOptions.vue settings
